import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import PermissionName from './PermissionName';
import PermissionCheckbox from './PermissionCheckboxContainer';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../modules/infra/feature-flags';

const Permissions = ({ shopUser, showEngagePermissionForBarbers, disableEngagePermission, ...props }) => (
  <div>
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb">Permissions</div>
    <div className="u-scrollable-x">
      <table className={cx('c-table-new c-table-permissions c-no-hover', { 'u-ml+': !shopUser })}>
        <thead>
          <tr>
            <th colSpan={2}>Type</th>
            <th>View</th>
            <th>Add/Edit</th>
            <th>Book</th>
            <th>Modify</th>
            <th>History</th>
            <th>Cancel</th>
            <th>Block Time</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <PermissionName>Appointments</PermissionName>
            <PermissionCheckbox id="appointments_view" name="permissions.appointments.view" colSpan={2} />
            <PermissionCheckbox id="appointments_book" name="permissions.appointments.book" />
            <PermissionCheckbox id="appointments_modify" name="permissions.appointments.modify" />
            <PermissionCheckbox id="appointments_history" name="permissions.appointments.history" />
            <PermissionCheckbox id="appointments_cancel" name="permissions.appointments.cancel" />
            <PermissionCheckbox
              id="appointments_block-time"
              name={shopUser ? 'permissions.blockTime.modify' : 'permissions.appointments.blockTime'}
            />
          </tr>
          <tr>
            <PermissionName>APPT Form - Show Contact Info</PermissionName>
            <PermissionCheckbox
              id="appointments_view_contact_info"
              name="permissions.appointments.show_contact_info"
              colSpan={7}
            />
          </tr>
          <tr>
            <PermissionName>Clients</PermissionName>
            <PermissionCheckbox id="clients_view" name="permissions.clients.view" />
            <PermissionCheckbox id="clients_modify" name="permissions.clients.modify" colSpan={6} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Barbers</PermissionName>
            <PermissionCheckbox id="barbers_view" name="permissions.barbers.view" />
            <PermissionCheckbox id="barbers_modify" name="permissions.barbers.modify" colSpan={6} />
          </tr>
          <tr>
            <PermissionName>Services</PermissionName>
            <PermissionCheckbox id="services_view" name="permissions.services.view" />
            <PermissionCheckbox id="services_modify" name="permissions.services.modify" colSpan={6} />
          </tr>
          <tr display-if={!shopUser}>
            <PermissionName>Schedules</PermissionName>
            <PermissionCheckbox id="workhours_view" name="permissions.workHours.view" />
            <PermissionCheckbox id="workhours_modify" name="permissions.workHours.modify" colSpan={6} />
          </tr>
          <tr display-if={!shopUser}>
            <PermissionName>Bank Accounts</PermissionName>
            <PermissionCheckbox id="bank-account_view" name="permissions.bankAccount.view" />
            <PermissionCheckbox id="bank-account_modify" name="permissions.bankAccount.modify" colSpan={6} />
          </tr>
          <tr>
            <PermissionName>Profile</PermissionName>
            <PermissionCheckbox id="profile_view" name="permissions.profile.view" />
            <PermissionCheckbox id="profile_modify" name="permissions.profile.modify" colSpan={6} />
          </tr>
          <tr display-if={props[flagNames.AUTOPAYOUT_SELF_SERVE]}>
            <PermissionName>Settings - Auto Payout</PermissionName>
            <PermissionCheckbox
              id="auto_payout_view"
              name="permissions.autoPayout.view"
              requiredFor={['permissions.autoPayout.modify']}
              tooltip="This permission grants this user the ability to view Auto Payout settings."
              colSpan={shopUser ? 1 : 7}
            />
            <PermissionCheckbox
              display-if={shopUser}
              id="auto_payout_modify"
              name="permissions.autoPayout.modify"
              colSpan={6}
              requires={['permissions.autoPayout.view']}
              tooltip="This permission grants this user the ability to edit Auto Payout settings."
            />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Settings - Shop Details</PermissionName>
            <PermissionCheckbox id="settings_view" name="permissions.settings.view" />
            <PermissionCheckbox id="settings_modify" name="permissions.settings.modify" colSpan={6} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Settings - Barber Settings</PermissionName>
            <PermissionCheckbox id="barberSettings_view" name="permissions.barberSettings.view" />
            <PermissionCheckbox id="barberSettings_modify" name="permissions.barberSettings.modify" colSpan={6} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Settings - Bank Account</PermissionName>
            <PermissionCheckbox id="bank-account_view" name="permissions.bankAccount.view" />
            <PermissionCheckbox id="bank-account_modify" name="permissions.bankAccount.modify" colSpan={6} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Settings - Taxes</PermissionName>
            <PermissionCheckbox id="taxes_view" name="permissions.taxes.view" />
            <PermissionCheckbox id="taxes_modify" name="permissions.taxes.modify" colSpan={6} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Settings - Discounts</PermissionName>
            <PermissionCheckbox id="discounts_view" name="permissions.discounts.view" />
            <PermissionCheckbox id="discounts_modify" name="permissions.discounts.modify" colSpan={6} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Settings - Promos</PermissionName>
            <PermissionCheckbox id="promos_view" name="permissions.promos.view" />
            <PermissionCheckbox id="promos_modify" name="permissions.promos.modify" colSpan={6} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Settings - Waiting List</PermissionName>
            <PermissionCheckbox id="waitingList_view" name="permissions.waitingList.view" />
            <PermissionCheckbox id="waitingList_modify" name="permissions.waitingList.modify" colSpan={6} />
          </tr>
          <tr>
            <PermissionName>Reports</PermissionName>
            <PermissionCheckbox id="reports_view" name="permissions.reports.view" colSpan={7} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Time Reports</PermissionName>
            <PermissionCheckbox id="time_reports_view" name="permissions.timeTrack.view" colSpan={7} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Products</PermissionName>
            <PermissionCheckbox
              id="products_view"
              name="permissions.products.view"
              requiredFor={['permissions.products.modify', 'permissions.inventory.modify']}
            />
            <PermissionCheckbox
              id="products_modify"
              name="permissions.products.modify"
              colSpan={6}
              requires={['permissions.products.view']}
            />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName nested>Inventory</PermissionName>
            <PermissionCheckbox />
            <PermissionCheckbox
              id="inventory_modify"
              name="permissions.inventory.modify"
              colSpan={6}
              requires={['permissions.products.view']}
              tooltip="This permission grants this user the ability to use the Stock Taking,
              New Inventory and Low Inventory Report"
            />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Dashboard</PermissionName>
            <PermissionCheckbox id="dashboard_view" name="permissions.dashboard.view" colSpan={7} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Analytics</PermissionName>
            <PermissionCheckbox id="analytics_view" name="permissions.analytics.view" colSpan={7} />
          </tr>
          <tr display-if={shopUser || showEngagePermissionForBarbers}>
            <PermissionName>Engage</PermissionName>
            <PermissionCheckbox
              id="engage_view"
              name="permissions.engage.view"
              colSpan={7}
              disabled={disableEngagePermission}
            />
          </tr>
          <tr>
            <PermissionName>Register</PermissionName>
            <PermissionCheckbox id="register_view" name="permissions.register.view" colSpan={7} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Register - Cash Register</PermissionName>
            <PermissionCheckbox id="cash_register_view" name="permissions.cashRegister.view" colSpan={7} />
          </tr>
          <tr>
            <PermissionName>Register - Open Cash Drawer</PermissionName>
            <PermissionCheckbox id="cash_register_modify" name="permissions.cashRegister.modify" colSpan={7} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Register - Daily Summary</PermissionName>
            <PermissionCheckbox id="daily_summary_view" name="permissions.dailySummary.view" colSpan={7} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Register - Daily Summary - History</PermissionName>
            <PermissionCheckbox
              id="daily_summary_history_view"
              name="permissions.dailySummaryHistory.view"
              colSpan={7}
            />
          </tr>
          <tr>
            <PermissionName>Register - Custom Charge</PermissionName>
            <PermissionCheckbox id="custom_charge" name="permissions.customCharge.view" colSpan={7} />
          </tr>
          <tr display-if={shopUser}>
            <PermissionName>Kiosk</PermissionName>
            <PermissionCheckbox id="kiosk" name="permissions.kiosk.view" colSpan={7} />
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);

Permissions.propTypes = {
  shopUser: PropTypes.bool,
  showEngagePermissionForBarbers: PropTypes.bool,
  disableEngagePermission: PropTypes.bool,
};

Permissions.defaultProps = {
  shopUser: false,
  showEngagePermissionForBarbers: false,
  disableEngagePermission: false,
};

export default withInjectFeatureFlagsToProps([flagNames.AUTOPAYOUT_SELF_SERVE])(Permissions);
